// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__5wXFg","question":"Question_question__2LK4h","description":"Question_description__1qyWc"};